import React from "react";
import { Link } from "react-router-dom";
import { MONEY_STRONG_PLAN_NAME } from "./moneyPlanCopy";
import "./Privacy_policy.css";

function PrivacyPolicy() {
  return (
    <div className="MoneyPolicy">
      <div className="MoneyPolicy-inner">
        <h1>プライバシーポリシー（ととのう固定費）</h1>
        <p className="muted">
          ととのう固定費（以下「本アプリ」）は、作田陽樹（以下「開発者」）が提供する iOS アプリです。
          本アプリにおける利用者情報の取扱いについて、以下のとおり定めます。
        </p>

        <p className="muted">
          目次：1. 取得する情報 / 2. 利用目的 / 3. 第三者提供 / 4. 外部サービス / 5. サブスクリプション・決済 /
          6. 安全管理 / 7. 開示・訂正・削除 / 8. データの保存と削除 / 9. 本ポリシーの変更 / 10. お問い合わせ /
          11. 改定日
        </p>

        <h2>1. 取得する情報</h2>
        <p>開発者は、本アプリの提供にあたり、以下の情報を取得する場合があります（必要最小限とします）。</p>
        <ul>
          <li>
            <strong>アカウント情報</strong>：メールアドレス、Sign in with Apple により提供される識別子等（認証に必要な範囲）。
            パスワードは認証基盤（Supabase Auth）により処理され、開発者が平文で保持することはありません。
          </li>
          <li>
            <strong>アプリ内データ</strong>：固定費名、金額、支払い頻度、カテゴリ、ローン条件、メモ、URL 等、利用者が入力した内容。
          </li>
          <li>
            <strong>技術情報</strong>：不具合調査・品質改善のための端末情報（OS 種別/バージョン、アプリバージョン等）、クラッシュログ、利用状況の分析データ（Firebase Analytics 等）。
          </li>
          <li>
            <strong>通知関連</strong>：支払いリマインド等のローカル通知の設定状態。プッシュ通知を利用する場合は、デバイストークン等を取得することがあります。
          </li>
        </ul>

        <h2>2. 利用目的</h2>
        <p>取得した情報は、以下の目的で利用します。</p>
        <ul>
          <li>本アプリの提供、本人確認、ログイン管理のため</li>
          <li>固定費データの保存、同期、表示、集計・シミュレーション等の機能提供のため</li>
          <li>{MONEY_STRONG_PLAN_NAME}の提供・権限管理のため</li>
          <li>不具合対応、品質改善、セキュリティ確保のため</li>
          <li>お問い合わせ対応、重要なお知らせの連絡のため</li>
          <li>不正利用防止・規約違反への対応のため</li>
          <li>利用状況の分析およびサービス改善のため（匿名化・統計化を含む）</li>
        </ul>

        <h2>3. 第三者提供</h2>
        <p>
          開発者は、法令に基づく場合等を除き、利用者の同意なく個人情報を第三者へ提供しません。
          ただし、利用目的の達成に必要な範囲で取扱いを委託する場合があります。
        </p>

        <h2>4. 外部サービス（委託先）</h2>
        <p>本アプリは、以下の外部サービスを利用することがあります。各提供者は、自社のプライバシーポリシーに従って情報を取り扱います。</p>
        <ul>
          <li>
            <strong>Supabase</strong>（認証、データベース、サーバー機能）：アカウント情報および同期対象の固定費データの保存
          </li>
          <li>
            <strong>Apple Sign in / App Store</strong>：認証、サブスクリプションの購入・管理
          </li>
          <li>
            <strong>Google Firebase</strong>（Analytics、Crashlytics 等）：利用状況の分析、クラッシュレポート
          </li>
        </ul>

        <h2>5. サブスクリプション・決済</h2>
        <p>
          {MONEY_STRONG_PLAN_NAME}の購入・課金・解約・返金は Apple が管理します。開発者は、クレジットカード番号等の決済情報を直接取得・保存しません。
          サブスクリプションの状態確認のため、Apple から提供される取引に関する情報を参照する場合があります。
          料金の詳細は
          <Link to="/money/fee"> 料金ページ</Link>
          および
          <Link to="/money/terms"> 利用規約</Link>
          をご覧ください。
        </p>

        <h2>6. 安全管理措置</h2>
        <p>
          開発者は、情報の漏えい、滅失、毀損等を防止するため、アクセス制御、通信の暗号化（HTTPS）、委託先の選定等、合理的な安全管理措置を講じます。
        </p>

        <h2>7. 開示・訂正・削除等</h2>
        <p>
          利用者は、法令の範囲内で、保有個人データの開示、訂正、利用停止、削除等を求めることができます。
          具体的な手続は「10. お問い合わせ」記載の窓口へご連絡ください。
        </p>

        <h2>8. データの保存と削除（アプリ削除/アカウント削除）</h2>
        <p>
          本アプリは、ログイン後のデータ同期のため、利用者が入力した固定費データをクラウド（Supabase）上に保存する場合があります。
          端末内にも SwiftData 等によりデータが保存されます。
          <strong>端末からアプリを削除しただけでは、クラウド上のデータが残る場合があります</strong>。
        </p>
        <p>
          データの削除を希望する場合は、本アプリのアカウント画面からアカウント削除を実行するか、実行できない場合は「10.
          お問い合わせ」へご連絡ください。サブスクリプションの解約は、App Store の設定から別途行ってください（
          <Link to="/money/withdrawal"> 解約手順</Link>
          ）。
        </p>

        <h2>9. 本ポリシーの変更</h2>
        <p>開発者は、必要に応じて本ポリシーを変更します。変更後の内容は、本ページ等の適切な方法で周知します。</p>

        <h2>10. お問い合わせ</h2>
        <p>
          本アプリに関するお問い合わせは、以下へご連絡ください。
          <br />
          個人情報取扱い責任者：作田陽樹
          <br />
          メールアドレス：haruki2021promoter@gmail.com
        </p>

        <h2>11. 改定日・制定日</h2>
        <p>
          改定日：2026年5月15日
          <br />
          制定日：2026年5月15日
        </p>

        <p className="muted">
          ※ 本アプリは現時点で<strong>第三者広告</strong>を配信していません。{MONEY_STRONG_PLAN_NAME}は App Store 経由のサブスクリプションです。
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
